// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partner-auth-header {
  display: flex;
  min-height: 76px;
  align-items: center;
  justify-content: space-between;
  padding: 0 clamp(24px, 5vw, 72px);
  border-bottom: 1px solid #e8edf2;
  background: rgba(255, 255, 255, 0.96);
}

.partner-auth-header__brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #10233d;
  text-decoration: none;
}

.partner-auth-header__brand img {
  width: 38px;
  height: 38px;
  object-fit: contain;
}

.partner-auth-header__brand span {
  display: grid;
  line-height: 1.05;
}

.partner-auth-header__brand strong {
  font-size: 18px;
  letter-spacing: -0.035em;
}

.partner-auth-header__brand small {
  margin-top: 3px;
  color: #66758a;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.05em;
}

.partner-auth-header__actions {
  display: flex;
  align-items: center;
  gap: 22px;
}

.partner-auth-header__actions > a {
  display: inline-flex;
  align-items: center;
  color: #526174;
  text-decoration: none;
}

.partner-auth-header__actions > a:focus-visible {
  outline: 3px solid rgba(49, 141, 204, 0.3);
  outline-offset: 4px;
}

.partner-auth-header__cancel {
  min-height: 36px;
  padding: 0 20px;
  justify-content: center;
  border: 1px solid #dfe5eb;
  border-radius: 999px;
  color: #263446 !important;
  font-size: 12px;
  font-weight: 650;
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.partner-auth-header__cancel:hover {
  border-color: #318dcc;
  transform: translateY(-1px);
}

@media (max-width: 520px) {
  .partner-auth-header {
    min-height: 66px;
    padding: 0 18px;
  }
  .partner-auth-header__brand img {
    width: 32px;
    height: 32px;
  }
  .partner-auth-header__brand strong {
    font-size: 16px;
  }
  .partner-auth-header__actions {
    gap: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PartnerAuthHeader.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;EACA,iCAAA;EACA,gCAAA;EACA,qCAAA;AACF;;AAEA;EAA8B,oBAAA;EAAsB,mBAAA;EAAqB,SAAA;EAAW,cAAA;EAAgB,qBAAA;AAMpG;;AALA;EAAkC,WAAA;EAAa,YAAA;EAAc,mBAAA;AAW7D;;AAVA;EAAmC,aAAA;EAAe,iBAAA;AAelD;;AAdA;EAAqC,eAAA;EAAiB,wBAAA;AAmBtD;;AAlBA;EAAoC,eAAA;EAAiB,cAAA;EAAgB,cAAA;EAAgB,gBAAA;EAAkB,sBAAA;AA0BvG;;AAzBA;EAAgC,aAAA;EAAe,mBAAA;EAAqB,SAAA;AA+BpE;;AA9BA;EAAoC,oBAAA;EAAsB,mBAAA;EAAqB,cAAA;EAAgB,qBAAA;AAqC/F;;AApCA;EAAkD,0CAAA;EAA2C,mBAAA;AAyC7F;;AAxCA;EAA+B,gBAAA;EAAkB,eAAA;EAAiB,uBAAA;EAAyB,yBAAA;EAA2B,oBAAA;EAAsB,yBAAA;EAA2B,eAAA;EAAiB,gBAAA;EAAkB,uDAAA;AAoD1M;;AAnDA;EAAqC,qBAAA;EAAuB,2BAAA;AAwD5D;;AAtDA;EACE;IAAuB,gBAAA;IAAkB,eAAA;EA2DzC;EA1DA;IAAkC,WAAA;IAAa,YAAA;EA8D/C;EA7DA;IAAqC,eAAA;EAgErC;EA/DA;IAAgC,SAAA;EAkEhC;AACF","sourcesContent":[".partner-auth-header {\n  display: flex;\n  min-height: 76px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 clamp(24px, 5vw, 72px);\n  border-bottom: 1px solid #e8edf2;\n  background: rgba(255, 255, 255, .96);\n}\n\n.partner-auth-header__brand { display: inline-flex; align-items: center; gap: 10px; color: #10233d; text-decoration: none; }\n.partner-auth-header__brand img { width: 38px; height: 38px; object-fit: contain; }\n.partner-auth-header__brand span { display: grid; line-height: 1.05; }\n.partner-auth-header__brand strong { font-size: 18px; letter-spacing: -.035em; }\n.partner-auth-header__brand small { margin-top: 3px; color: #66758a; font-size: 9px; font-weight: 700; letter-spacing: .05em; }\n.partner-auth-header__actions { display: flex; align-items: center; gap: 22px; }\n.partner-auth-header__actions > a { display: inline-flex; align-items: center; color: #526174; text-decoration: none; }\n.partner-auth-header__actions > a:focus-visible { outline: 3px solid rgba(49, 141, 204, .3); outline-offset: 4px; }\n.partner-auth-header__cancel { min-height: 36px; padding: 0 20px; justify-content: center; border: 1px solid #dfe5eb; border-radius: 999px; color: #263446 !important; font-size: 12px; font-weight: 650; transition: border-color .2s ease, transform .2s ease; }\n.partner-auth-header__cancel:hover { border-color: #318dcc; transform: translateY(-1px); }\n\n@media (max-width: 520px) {\n  .partner-auth-header { min-height: 66px; padding: 0 18px; }\n  .partner-auth-header__brand img { width: 32px; height: 32px; }\n  .partner-auth-header__brand strong { font-size: 16px; }\n  .partner-auth-header__actions { gap: 14px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
